import { create } from "zustand";
import { persist } from "zustand/middleware";
import { getHolidayBanner } from "network/services/holidayBanner";
import { subtractDates } from "utils/helpers";

interface HolidayBanneInterface {
  loading: boolean;
  error: boolean;
}

interface HolidayBannerData {
  field_holiday_banner_link: string;
  field_hbanner_short_description: string;
  field_imageholiday: string;
}
const INITIAL_STATE = {
  field_holiday_banner_link: "",
  field_hbanner_short_description: "",
  field_imageholiday: "",
};

const fetchHolidayBanner = async (): Promise<HolidayBannerData | null> => {
  try {
    if (location.pathname === "/forexrates/store-digitalscreens") {
      return INITIAL_STATE;
    }
    const { data } = await getHolidayBanner();

    if (data.length === 0) {
      return INITIAL_STATE;
    }
    let load = data[0];
    if (load?.countdown !== "") {
      const countdown_value = subtractDates(
        new Date(load?.countdown),
        new Date()
      );

      const replacementkey = `${load?.replacement_key || "star"}`;
      const field_hbanner_short_description =
        load.field_hbanner_short_description.replaceAll(
          replacementkey,
          countdown_value.toString()
        );
      load.field_hbanner_short_description = field_hbanner_short_description;
    }

    return load;
  } catch (e) {
    return INITIAL_STATE;
  }
};

let holidaybanner = (set): HolidayBannerData & HolidayBanneInterface => ({
  loading: false,
  error: false,
  field_holiday_banner_link: "",
  field_hbanner_short_description: "",
  field_imageholiday: "",
  getHolidayBanner: async (): Promise<void> => {
    const holidayBannerData = await fetchHolidayBanner();
    if (!holidayBannerData) {
      return;
    }
    set({ ...holidayBannerData });
  },
});

holidaybanner = persist(holidaybanner, { name: "holiday_banner_store" });

export const useHolidayBanner = create(holidaybanner);
